<template>
    <section 
        class="triplea-banner-section"
        :style="{ background: `${bg}` }"
    >
    <div class="triplea-banner-wrapper" 
        :style="{ 
            background: isMobile 
            ? `url(${require('@/assets/img/triplea/home/apolar-procura-banner.png')}) no-repeat center/cover` 
            : `url(${require('@/assets/img/triplea/home/banner-bg.png')}) no-repeat center/cover`
        }"
        >
            
            <div class="triplea-container small">
                <div class="triplea-banner-section-row">
                    <div class="triplea-banner-content-bloc">
                        <h2>
                            Ainda não achou<br/>
                            o imóvel ideal?
                        </h2>
                        <p>
                            Conheça o Apolar Procura, <br/>
                            A ferramenta que combina para você!
                        </p>
                        <a href="https://procura.apolar.com.br/" class="triplea-banner-button">Saiba mais</a>
                    </div>
                    <div class="triplea-banner-logo-bloc">
                        <img src="@/assets/img/triplea/home/apolar-procura.svg"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import "@/assets/scss/custom/triplea/components/_home_banner_section.scss";
    export default {
        props: {
            bg: {
                type: String,
                default: "#EFEBE7",
            },
        },
    };
</script>
